import { ShiftStatus } from '../../../common/types';

import { type ShiftStore } from './types';

export const initialState: ShiftStore = {
	cards: [],
	status: ShiftStatus.Default,
};
